import {type UppyFile} from '@uppy/core';
import {URL} from '@netx/core-next/url';
import {useSessionStore} from '@netx/core-auth-next/store';
import type {XHRUploadOptions as IXHRUploadOptions} from '../../lib/multi-destination';

export type XHRUploadOptions = Partial<IXHRUploadOptions>;

export const xhrGetResponseData = (responseText: string) => {
	if (responseText === '<exogen>done</exogen>') {
		return {
			success: true,
		};
	}
	// TODO: log uppy error
	return {};
};

export const xhrHeaders = (file: UppyFile) => {
	const headers: {[name: string]: string | number} = {};
	
	if (useSessionStore.getState().isToken) headers['NX-Auth-Token'] = useSessionStore.getState().key || '';

	// TODO: wtf is up with the typing here...
	return headers as unknown as {
		[name: string]: string | number;
	};
};

/**
 * Utility for creating uppy xhr plugin options
 * @param options overrides
 * @returns Uppy xhr plugin options
 */
export const createXHROptions = (options: XHRUploadOptions = {}) => {
	const xhrOptions: IXHRUploadOptions = {
		endpoint: URL.upload,
		formData: true,
		method: 'POST',

		// Because of the legacy servlet
		getResponseData: xhrGetResponseData,
		...options,
		headers: xhrHeaders,
	};
	return xhrOptions;
};

export default createXHROptions;
